/* Copyright 2020 The MathWorks, Inc. */
define(['mw-widget-api/WidgetBase',
    'mw-widget-api/defineWidget',
    'mw-widget-api/facade/html'], function (WidgetBase, defineWidget, html) {
    'use strict';

    class RatingFeedbackStep extends WidgetBase {
        static get properties () {
            return {
                step: {
                    reflect: true,
                    type: Number
                }
            };
        }

        constructor () {
            super();
            this.step = 0;
        }
    }
    return defineWidget({
        name: 'mw-rating-feedback-step',
        widgetClass: RatingFeedbackStep
    });
});
